jQuery(document).ready(function($) {
    // Initialisiere Slider nur für Elemente mit data-type="slider"
    function initSlider() {
        $('.component-logo-grid[data-type="slider"]').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 0, // Keine Pause zwischen den Slides
            speed: 5000, // Dauer der Übergangsanimation in ms
            cssEase: 'linear', // Lineare Animation für gleichmäßige Bewegung
            infinite: true,
            arrows: false,
            dots: false,
            pauseOnHover: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 5
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });
    }

    // Initial starten
    initSlider();

    // Bei Resize neu initialisieren
    var resizeTimer;
    $(window).on('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            $('.component-logo-grid[data-type="slider"]').slick('unslick');
            initSlider();
        }, 250);
    });
});
